<template>
<div>
	<div class="panel panel-default" v-if="!isUpdate">
		<ly-fixheader title="查看文章信息" btn="edit">
			<div class="btn-group pull-right pr15" v-if="info.status==1" slot="s1">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right" v-on:click="changeStatus"> 
					<i class="glyphicon glyphicon-arrow-down"></i>
					设为下架
				</a>
			</div>	
			<div class="btn-group pull-right pr15" v-else  slot="s1">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right" v-on:click="changeStatus"> 
					<i class="glyphicon glyphicon-arrow-up"></i>
					设为上架
				</a>
			</div>
		</ly-fixheader>	
  		<div class="panel-body">
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-2 control-label">类型:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.type_name}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">主标题:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.title}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">发布人:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.publisher}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">发布日期:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.publish_time}}</label>
					</div>
				</div>
				<div class="form-hr"></div>
				<div class="form-group" v-if="info.status==1">
					<label class="col-sm-2 control-label">状态:</label>
					<div class="col-sm-10">
						<label class="control-label">上架</label>
					</div>
				</div>
				<div class="form-group" v-else>
					<label class="col-sm-2 control-label">状态:</label>
					<div class="col-sm-10">
						<label class="control-label">下架</label>
					</div>
				</div>
				<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">正文</label>
					<div class="col-sm-8">
						<label class="control-label" style="text-align:left;">{{{info.content}}}</label>
					</div>
				</div>
			</form>
		</div>
  	</div>
  	<ly-articleupdate v-if="isUpdate" :info="info"></ly-articleupdate>
 </div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var info = {};//文章详情
	module.exports = {
		data : function(){
			return {
				isUpdate : false,
				info : {}
			}
		},
		components : {
			'ly-articleupdate' : require('./article_add.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue')
		},
		ready : function () {
			var self = this;
			var aid = this.$route.params['aid'];//获得文章的ID
			Http['article'].query({
				key : [aid],
				succ : function(rs){
					rs['id'] = aid;
					self.$set('info',rs);
				}
			});
		},
		methods : {
			/**
			 * 设为下架
			 */
			changeStatus: function() {
				var artInfo = this.info;
				var aid = this.$route.params['aid'];//获得文章的ID
				if(artInfo.status==1) {
					Common.confirm("确定将本文章设为下架吗?",function(){
						Http['article'].deleteStatus({
							key : [aid,aid],
							succ : function(rs){
								artInfo.status = 0;
								Common.tipDialog("成功设为下架!",1500,"success");
							},
							err : function(rs) {
								Common.tipDialog("操作失败!",1500,"error");
							}
						});
					});
				} else {
					Common.confirm("确定将本文章设为上架吗?",function(){
						Http['article'].createStatus({
							key : [aid],
							succ : function(rs){
								artInfo.status = 1;
								Common.tipDialog("成功设为上架!",1500,"success");
							},
							err : function(rs) {
								Common.tipDialog("操作失败!",1500,"error");
							}
						});
					});
				}
				
			}
		},
		events : {
			doUpdate : function(){
				this.isUpdate = true;
			},
			closeUpdate : function(){
				this.isUpdate = false;
			},
			goback: function() {
				Common.go('article_list');
			}
		}
	};
</script>


/** WEBPACK FOOTER **
 ** article_info.vue?5c7b5ec2
 **/